import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LiveClassWithCountdownTimerComponent } from './live-class-with-countdown-timer.component';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassWithCountdownTimerPlusMinutesComponent extends LiveClassWithCountdownTimerComponent {
  protected signUpConfigValue: number = 0;

  public get minutesForGroup() {
    const signupStart = this.signUpConfigValue / 1000 / 60;
    return (Number(this.minutes) + Math.trunc(signupStart)).toString();
  }

  public get labelKeyForGroup() {
    return 'oeapp.studybundle.gc.classStartsIn';
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/live-class-with-countdown-timer/live-class-with-countdown-timer-plus-minutes.component.ts